module.exports = __webpack_public_path__ + "static/media/hamamo_top_logo_delivery.3f3d1631.png";